import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CheckCircle, Star } from 'lucide-react';

const SuccessDialog = ({ isOpen, onClose, bookingDetails }) => {
  const handleGoogleReview = () => {
    // Open Google review page in new tab
    window.open('https://g.page/r/CUqFJnGorwnHEAE/review', '_blank');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="success-dialog">
        <DialogHeader>
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
          </div>
          <DialogTitle className="text-2xl font-semibold text-center">
            Buchung erfolgreich!
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {bookingDetails && (
            <div className="p-4 bg-slate-50 rounded-lg space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-slate-600">Service:</span>
                <span className="font-semibold text-slate-900">{bookingDetails.service}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-600">Datum:</span>
                <span className="font-semibold text-slate-900">{bookingDetails.date}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-slate-600">Uhrzeit:</span>
                <span className="font-semibold text-slate-900">{bookingDetails.time} Uhr</span>
              </div>
            </div>
          )}

          <div className="text-center">
            <p className="text-slate-600 mb-4">
              {`Die Bestätigung wird an ${bookingDetails?.email || 'Ihre E-Mail-Adresse'} gesendet.`}
            </p>
          </div>

          {/* Google Review Section */}
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-xl text-center">
            <div className="flex justify-center mb-3">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <h3 className="font-semibold text-slate-900 mb-2">
              Hat Ihnen unser Service gefallen?
            </h3>
            <p className="text-sm text-slate-600 mb-4">
              Teilen Sie Ihre Erfahrung mit anderen auf Google!
            </p>
            <Button
              onClick={handleGoogleReview}
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-full w-full"
              data-testid="google-review-button"
            >
              <Star className="w-4 h-4 mr-2" />
              Jetzt auf Google bewerten
            </Button>
          </div>

          <Button
            onClick={onClose}
            variant="outline"
            className="w-full rounded-full"
            data-testid="close-success-dialog"
          >
            Schließen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
